<template>
  <div class="block-steps pt-12 pb-11">
    <bim-container>
      <bimCol cols=12 md=10 class="d-flex flex-column align-center mx-auto block-steps">
        <bim-text type=h5 bold class="block-steps__title mb-10 cursor-pointer">Процесс создания спецификации сегодня</bim-text>
        <div class="d-flex justify-center align-center">
          <bim-text
            type=medium
            bold
            class="cursor-pointer"
            :class="{ 'block-steps__text--active': !check }"
          >
            <span @click="setChecked(false)">Без Мастера спецификаций</span>
          </bim-text>
          <div @click="setChecked(!check)" class="mx-6 cursor-pointer">
            <bim-tumbler
              :persistentRadio="false"
              name="name"
              class="block-steps__tumbler"
              :value="check"
            />
          </div>
          <bim-text
            type=medium
            bold
            class="cursor-pointer"
            :class="{ 'block-steps__text--active': check }"
          >
            <span @click="setChecked(true)">С Мастером спецификаций</span>
          </bim-text>
        </div>

        <div class="d-flex justify-center my-10">
          <img v-show="check" src="/dist/assets/front_white/img/landing__master/master-4.svg" alt="" />
          <img v-show="!check" src="/dist/assets/front_white/img/landing__master/master-2.svg" alt="" />
        </div>

        <ButtonPluginDownload />
      </bimCol>
    </bim-container>
  </div>
</template>

<script>
import ButtonPluginDownload from "./ButtonPluginDownload"

import bimTumbler from "@bimlib/components/bimTumbler"
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
export default {
  name: "",
  components: {
    ButtonPluginDownload,

    bimTumbler,
    bimContainer,
    bimCol,
  },
  data() {
    return {
      check: true,
    }
  },
  methods: {
    setChecked(value) {
      console.log('check')
      this.check = value
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/front_white/sass/components/settings";

.cursor-pointer {
  cursor: pointer;
}

.block-steps {
  background-color: #fafafa;

  .block-steps__title {
    text-align: center;
  }

  .block-steps__text--active {
    color: $primary-color;
  }

  .block-steps__tumbler {
    
    ::v-deep { 

      .tumbler__circle {
        background: $primary-color;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
      }

      .bim__tumbler {
        width: 40px;
        height: 16px;
        background: #eeeeee;
      }
    }
  }
}
</style>
